
/*
Autor: Patrick Alex Maia Duarte
Ref Autor: https://patrickduarte.github.io
RDM:428
Ano: 2022
Objetivo: Fazer edição do cadastro de categorias de links

*/

/**Vai fazer mudanças? Então identifique-se e descreva objetivo */

/**
 * Autor:
 * Ref Autor:
 * RDM:
 * Data:
 * Objetivo:
 */
import {computed,reactive,onMounted, ref} from "vue";
import {useRoute, useRouter} from "vue-router";
import {useStore} from "vuex";
import axios from 'axios';

import Tabs from "@/components/Tab/Tabs.vue";
import Tab from "@/components/Tab/Tab.vue";


export default {
  name: "CategoriaEdit",
  components:  { Tabs, Tab,},
  setup() {
    const data = reactive({
      id: '',
      short_name: '',
      long_name: '',
      note: '',
      msg:'',
      showtableFunc: false,
      success:false,
      error:false,
      achou:false,
      cont:0,
      insert:[]
      
    });
   // const roles = ref([]);

    const store = useStore();
    const user = computed( () => store.state.user);

    const router = useRouter();
    const route = useRoute();


    const linklist = ref([]);
    const linkselect= ref([]);
    const linkdata = ref([]);

    const userLinks = ref([]); 
    const categoriaLinks = ref([]); 
    
    const links = ref([]);
    const selectedLinks = ref(<any>[]);
    const excSelLinks = ref(<any>[]);
    const linkdisp = ref([]);

    const formData = reactive({
      insert: [] as number[],
      notinsert: [] as number[],
      update: [] as number[],
      notupdate: [] as number[],
      delete: [] as number[],
      notdelete: [] as number[]
    });

    
    onMounted(async () => {

      checkAcesso();


      const response = await axios.get(`categorias/${route.params.catid}`);

      data.id = response.data.id;
      data.short_name = response.data.short_name;
      data.long_name = response.data.long_name;
      data.note = response.data.note;


      getCategoriaLinks();//getProfileFuncs();


    });


    const checkAcesso = async () => {
        
        //verifica se o usuário clicou no link de função ou perfil. Também consulta acesso para operação escolhida
        if (route.params.t=== 'f'){
              const {data}= await axios.get(`btngetshowuserfunc/${route.params.id}/${user.value.id}`)

              if( data.update !== 1 ? true : false )
                await router.push('/acessonegado');
        }else if (route.params.t=== 'p'){

            if (!(user.value.id > 0))
               await router.push('/acessonegado');

            const {data}= await axios.get(`btngetshowperfilfunc/${route.params.id}/${route.params.perfil}`)

              if( data.update !== 1 ? true : false )
                await router.push('/acessonegado');

        }else {
          await router.push('/acessonegado');
        }
       
    }


const submit = async () => {
      await axios.put(`categorias/${route.params.catid}`, data);
      data.msg= 'Categoria atualizado';
      data.success = true;
      setTimeout( () => { data.msg= '';
                          data.success=false;
                          data.error=false;     
                         }
                ,500
                );
     // await router.push('/users');
}

const getCategoriaLinks = async () => {

       let achou = false;
       linkdisp.value = [];
        try {
          // console.log('começa aqui' );
            const resp = await axios.get(`getcategorialinks/${route.params.catid}`); 
            categoriaLinks.value = resp.data;
           // console.log(categoriaLinks.value );
            if (resp.data.length > 0){
              data.showtableFunc=true;
            }else{
              categoriaLinks.value = [];
              data.showtableFunc=false;
            }
    
            //Monta lista de links disponíveis
           // console.log('Busca links' );
            const response = await axios.get('linksistema'); 
            links.value = response.data;  
           // console.log(links.value );
            links.value.forEach((value, index) => {
              achou = false;
              categoriaLinks.value.forEach((v,ind ) => {
                if (value['id']=== v['id']){
                    achou=true;
                }
              })

              if (!achou)
              {
                linkdisp.value.push(value);
              }
            });
              
        } catch (e) {
               categoriaLinks.value = [];
              data.showtableFunc=false;
        } 
    }

    //Adicionar funções para usuário
    const storeCategoriaLink = async () => {

      try
      {
       // console.log("Chegou na storeUserFunc");
       // console.log(selectedFuncs.value);
        await axios.post( `categorialinks/${route.params.catid}`, {links:selectedLinks.value} );
        
        getCategoriaLinks();
      }catch (e) {
            data.msg= 'Falha na atualização';
            data.error = true;
      }finally {
      setTimeout( () => { data.msg= ''; 
                          data.success=false;
                          data.error=false;
                        }
                ,1000
                );
      }
    }

const selectIns = (id: number, checked: boolean) => {
  if (checked) {
    formData.insert = [...formData.insert, id];
    //console.log('Insert ' + formData.insert);
     formData.notinsert = formData.notinsert.filter(p => p !== id);
        // console.log('notinsert  ' + formData.notinsert);
    return;
  }else {
    formData.notinsert = [...formData.notinsert, id];
      //console.log('notinsert ' + formData.notinsert);
     formData.insert = formData.insert.filter(p => p !== id);
      //console.log('Insert ' + formData.insert);
    return;
  }

  }

const checkedIns = (id: number) => {
  if(id=== 1){
    return true;
   
  }
  else
  {

    return false;
  }
    
}

const selectUp = (id: number, checked: boolean) => {
  if (checked) {
    formData.update = [...formData.update, id];
     formData.notupdate = formData.notupdate.filter(p => p !== id);
    return;
  }else {
    formData.notupdate = [...formData.notupdate, id];
     formData.update = formData.update.filter(p => p !== id);
    return;
  }
}

const checkedUp = (id: number) => {
  if(id=== 1)
    return true;
  else
    return false;    
}



const selectDel = (id: number, checked: boolean) => {
  if (checked) {
    formData.delete = [...formData.delete, id];
     formData.notdelete = formData.notdelete.filter(p => p !== id);
    return;
  }else {
    formData.notdelete = [...formData.notdelete, id];
     formData.delete = formData.delete.filter(p => p !== id);
    return;
  }
}

const checkedDel = (id: number) => {
  if(id=== 1)
    return true;
  else
    return false;    
}

        //Excluir Funções do Perfil
const storeCategoriaLinkUpdate =async () => {
   // console.log('Items selecionados para exclusão ' + excSelFuncs.value);
      await axios.put( `categorialinks/${route.params.catid}`, {links:excSelLinks.value });
      excSelLinks.value = [];

      getCategoriaLinks();
    }




    return {
      data,
      submit,
      userLinks,
      categoriaLinks,
      getCategoriaLinks,
      linkdisp,
      links,
      selectedLinks,
      excSelLinks,
      storeCategoriaLink,
      storeCategoriaLinkUpdate,
      checkedIns,
      checkedUp,
      checkedDel,
      selectIns,     
      selectUp,
      selectDel
    }
  }

}
